<template>
  <div>
    <div class="hotel-room-skeleton" v-for="i in 5" :key="i">
      <div class="hotel-room-skeleton-title skeleton-box"></div>
      <div class="skeleton">
        <div class="skeleton-left">
          <div class="skeleton-box skeleton-large"></div>
          <div class="skeleton-small-box">
            <div class="skeleton-box skeleton-small"></div>
            <div class="skeleton-box skeleton-small"></div>
          </div>
          <div class="skeleton-box skeleton-medium"></div>
          <div class="skeleton-box skeleton-line"></div>
        </div>
        <div class="skeleton-right">
          <div class="skeleton-card">
            <div class="skeleton-box skeleton-title"></div>
            <div class="skeleton-box skeleton-medium"></div>
            <div class="skeleton-box skeleton-medium"></div>
            <hr>
            <div class="skeleton-bottom-row">
              <div class="skeleton-box skeleton-btn"></div>
              <div class="skeleton-box skeleton-btn"></div>
            </div>
          </div>
          <div class="skeleton-card">
            <div class="skeleton-box skeleton-title"></div>
            <div class="skeleton-box skeleton-medium"></div>
            <div class="skeleton-box skeleton-medium"></div>
            <hr>
            <div class="skeleton-bottom-row">
              <div class="skeleton-box skeleton-btn"></div>
              <div class="skeleton-box skeleton-btn"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.skeleton {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;

  @media screen and (max-width: 992px) {
    flex-direction: column;
  }
}

.skeleton-box {
  background: #e0e0e0;
  border-radius: 8px;
  animation: pulse 1.5s infinite ease-in-out;
}


.skeleton-left {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;

  @media screen and (max-width: 992px) {
    flex-direction: column;
  }
}

.skeleton-large {
  width: 100%;
  height: 180px;
  border-radius: 8px;
}

.skeleton-small-box {
  display: flex;
  gap: 8px;
}

.skeleton-small {
  width: 80px;
  height: 20px;
  border-radius: 4px;
}

.skeleton-line {
  width: 105px;
  height: 16px;
  border-radius: 4px;
}

.hotel-room-skeleton-title {
  width: 172px;
  height: 32px;
  border-radius: 6px;
  margin-bottom: 12px;
}

.skeleton-title {
  width: 100%;
  height: 26px;
  border-radius: 4px;
}

.skeleton-medium {
  width: 80%;
  height: 16px;
  border-radius: 4px;
}

/* Правая часть */
.skeleton-right {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.skeleton-card {
  width: 453px;
  border-radius: 8px;
  border: 1px solid #ddd;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  .skeleton-medium {
    margin-left: 20px;

    &:nth-child(2) {
      width: 253px;
    }
    &:nth-child(3) {
      width: 149px;
    }
  }

  .skeleton-line {
    &:nth-child(1) {
      width: 80%;
    }
    &:nth-child(2) {
      width: 60%;
    }
  }

  @media screen and (max-width: 992px) {
    width: 100%;
  }
}

.skeleton-btn {
  width: 119px;
  height: 36px;
  border-radius: 4px;
}

.skeleton-bottom-row {
  display: flex;
  justify-content: space-between;
  .skeleton-btn {
    &:first-child {
      width: 202px;
    }
  }
}

@keyframes pulse {
  0% {
    background-color: #e0e0e0;
  }
  50% {
    background-color: #f0f0f0;
  }
  100% {
    background-color: #e0e0e0;
  }
}
</style>
<script setup lang="ts">
</script>
